import { render, staticRenderFns } from "./GameDistributionChart.vue?vue&type=template&id=44e64daa&scoped=true"
import script from "./GameDistributionChart.vue?vue&type=script&lang=js"
export * from "./GameDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./GameDistributionChart.vue?vue&type=style&index=0&id=44e64daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e64daa",
  null
  
)

export default component.exports